import React, { useState, useEffect } from 'react';
import logo from '../stempz-logo.svg';
import { useBusinessForm } from './BusinessSignup';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openBusinessForm = useBusinessForm();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled
          ? 'bg-white shadow-md py-3'
          : 'bg-transparent py-5'
        }`}
    >
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button
              onClick={() => scrollToSection('hero')}
              className="flex items-center gap-2 text-2xl font-bold text-teal-600 hover:text-teal-700 transition-colors"
            >
              <img src={logo} alt="" className="h-9 w-9" />
              Stempz
            </button>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('deals')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Deals
            </button>
            <button
              onClick={() => scrollToSection('steder')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Steder
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Funksjoner
            </button>
            <button
              onClick={() => scrollToSection('for-businesses')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              For bedrifter
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Kontakt
            </button>
            <button
              onClick={openBusinessForm}
              className="border border-teal-600 text-teal-700 px-5 py-2 rounded-full font-semibold hover:bg-teal-50 transition-colors"
            >
              Kom i gang
            </button>
            <a
              href="#download"
              className="bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl"
            >
              Last ned appen
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700 focus:outline-none"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3 bg-white rounded-lg shadow-lg p-4">
            <button
              onClick={() => scrollToSection('deals')}
              className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2"
            >
              Deals
            </button>
            <button
              onClick={() => scrollToSection('steder')}
              className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2"
            >
              Steder
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2"
            >
              Funksjoner
            </button>
            <button
              onClick={() => scrollToSection('for-businesses')}
              className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2"
            >
              For bedrifter
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2"
            >
              Kontakt
            </button>
            <button
              onClick={() => { setIsMobileMenuOpen(false); openBusinessForm(); }}
              className="block w-full border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold text-center"
            >
              Kom i gang
            </button>
            <a
              href="#download"
              className="block w-full bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 transition-colors text-center"
            >
              Last ned appen
            </a>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;

